import _ from "underscore";
import $ from "jquery";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements, setUniqNamesAndIds} from "../../utilities/selectorHelpers";
import {createPreventDefault, isPresent, isTruthy, isBlank} from '../../utilities/general';

const elementsMap = {
  shippingType: '.shipping-type',
  freightShippingMessage: '.freight-shipping-message'
};

export default function ShippingTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const shippingTypesList = wizardElement.data('shipping-types');
  const els = {};

  self.init = function(){
    render();
  };

  function render(){
    setElements();
    loadDropDowns();
    bindElements();
  }

  function setElements() {
    setElementsFromScope(els, elementsMap, wizardElement);
  }

  function loadDropDowns() {
    $(shippingTypesList).each(function() {
      const option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
      els.shippingType.append(option);
    });    
  }

  function bindElements() {
    els.shippingType.on("change", handleShippingTypeChange);
  }

  function handleShippingTypeChange(e) {
    e.preventDefault();
    if($(this).val() === "LTL") {
      els.freightShippingMessage.show();
    } else {
      els.freightShippingMessage.hide();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/transferOrder/ShippingTab.js